// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pygU","title":"styles_title__2e0ZV"};